module.exports = __webpack_public_path__ + "images/goudse5a33631002ccbffe14508f8eb04875b3.png";